import { render, staticRenderFns } from "./TeamMenu.vue?vue&type=template&id=90abc890"
import script from "./TeamMenu.vue?vue&type=script&lang=js"
export * from "./TeamMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports